import { createSlice } from '@reduxjs/toolkit';

const UtmSlice = createSlice({
  name: 'utms',
  initialState: {},
  reducers: {
    addUtmParameters(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const { addUtmParameters } = UtmSlice.actions;

export default UtmSlice.reducer;
